export default {
	title: 'Grupy, do których należysz',
	search: 'Szukaj grupy'
}
